import React from 'react'
import PropTypes from 'prop-types'
import BaseButton from "./base-button";
import { AppDataContext } from '../../contexts/app-data';

const StepFooterAction = (props) => {
    const { state, dispatch } = React.useContext(AppDataContext)
    return (<div className={"footer-action"} style={{bottom: state.footer_height}}><BaseButton {...props}/></div>)
}

StepFooterAction.propTypes = {
    props: PropTypes.object
}

export default StepFooterAction